import * as types from '../constants/actionTypes'

const defaultState = {
  impressions: []
}

const buffer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CREATE_IMPRESSION:
      return {
        impressions: [...state.impressions, action.data]
      }

    case types.CLEAR_IMPRESSIONS:
      return defaultState

    default:
      return state
  }
}

export default buffer
